import React, { useEffect, useState } from 'react';

// Icon
import Sleep from '../../../assets/icons/Sleep';

// Kit
import { Card } from '@/components/ui';

import { useFetch } from 'use-http';
import { MAIN_API_URL } from '../../../configuration';
import { connect } from 'react-redux';

const OutOfScheduleQuestions = (props) => {
    const { startDate, endDate } = props;
    const [total, setTotal] = useState(0);
    const { get, response } = useFetch(MAIN_API_URL + '/stats/not_working', {
        headers: {
            'x-token': localStorage.getItem('token')
        }
    });

    const getStatsOutOfScheduleQuestions = async () => {
        const resp = await get("?startDate=" + startDate + "&endDate=" + endDate);
        if (response.ok) {
            setTotal(resp.total);
        }
    }

    useEffect(() => { getStatsOutOfScheduleQuestions(); }, [startDate, endDate]);

    return (
        <Card hover className="flex items-center justify-between gap-3 p-4">
            <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-secondary text-foreground [&>svg]:size-[22px]">
                    <Sleep />
                </span>
                <h2 className="text-[15px] font-semibold leading-tight tracking-[-0.01em] text-foreground">
                    Preguntas fuera de horario
                </h2>
            </div>
            <span className="deck-kpi tabular text-2xl text-foreground">{total}</span>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        startDate: state.employees.filterDates.startDate,
        endDate: state.employees.filterDates.endDate,
    }
}

export default connect(mapStateToProps, null)(OutOfScheduleQuestions);
